import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import MergerOperationService from './service/MergerOperationService';
import MergerFunctionBarService from '@/presentation/pages/detail/detail-merger/service/MergerFunctionBarService';
import responseKeyNormalizerMapping from './mapping';
export default class MergerDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore todo
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return MergerOperationService;
    }
    get FunctionBarServiceClass() {
        return MergerFunctionBarService;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 5,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailMergerRoot' },
        };
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(location) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(location),
            };
        }
        return {
            path: 'merger',
            name: 'detailMergerRoot',
            redirect: `${self.PLUGIN_BASIC_PATH}/${this.name}/folders`,
            // @ts-ignore
            component: () => import('./MergerDetail.vue'),
            props: getDetailPageProps,
            children: [
                {
                    path: 'folders',
                    name: 'mergerFolderPage',
                    // @ts-ignore
                    component: () => import('./plugin-view/Folder.vue'),
                    props: getDetailPageProps,
                },
            ],
        };
    }
}
